import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import styles from "../EditDiv/EditDiv.module.css";
import buttonStyles from "../YesNoButtonsCSS/YesNoButtons.module.css";
import BlueLogo from "../../assets/BlueLogo.png";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "../../redux/store";
import { exportKFInvoiceByNumber, setSuccess, hasError } from "../../redux/slices/kfInvoiceExport";

const KFInvoiceExportPopup = ({ isVisible, onClose }) => {
  const dispatch = useDispatch();
  const kfExportState = useSelector((state) => state.kfInvoiceExport || {});
  const { enqueueSnackbar } = useSnackbar();

  // Clear any previous success state when this popup opens
  useEffect(() => {
    if (isVisible) {
      dispatch(setSuccess(null));
    }
  }, [isVisible, dispatch]);

  // Handle success/error messages
  useEffect(() => {
    if (kfExportState.successMessage) {
      const msg = kfExportState.successMessage;
      enqueueSnackbar(msg, { variant: "success" });
      // Clear redux success so subsequent opens don't immediately close
      dispatch(setSuccess(null));
      // Close popup on success
      if (typeof onClose === "function") onClose();
    }
    if (kfExportState.error) {
      const errMsg = kfExportState.error?.message || String(kfExportState.error);
      enqueueSnackbar(errMsg, { variant: "error" });
      // Keep error in redux for debugging but clear it so UI won't be sticky
      dispatch(hasError(null));
    }
  }, [kfExportState.successMessage, kfExportState.error, enqueueSnackbar, onClose, dispatch]);

  const formik = useFormik({
    initialValues: {
      invoiceNumber: "",
    },
    validationSchema: Yup.object().shape({
      invoiceNumber: Yup.string()
        .required("Invoice number is required")
        .matches(/^\d+$/, "Invoice number must contain only digits"),
    }),
    onSubmit: async (values) => {
      try {
        await dispatch(exportKFInvoiceByNumber(values.invoiceNumber));
        // Success handling is done by the useEffect above
      } catch (e) {
        // Error handling is done by the useEffect above
      }
    },
  });

  if (!isVisible) return null;

  return (
    <div className={styles.backGround}>
      <div className={styles.form} style={{ width: "400px" }}>
        <div className={styles.momentTitle}>MOMENT</div>
        <div className={styles.sectionTitle}>KF Export - Invoice Download</div>

        <div style={{ marginTop: '15px', marginBottom: '10px', width: '100%' }}>
          <p style={{ fontSize: '14px', color: '#666', textAlign: 'center', lineHeight: '1.4' }}>
            Enter an invoice number to download the invoice information. The invoice must be older than 45 days to be eligible for export.
          </p>
        </div>

        <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
          <div className={styles.List}>
            <p className={styles.dataTitleV2}>Invoice Number*:</p>
            <div className={styles.commentHolder}>
              <input
                className={styles.Comment}
                style={{ height: '20px' }}
                type="text"
                value={formik.values.invoiceNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="invoiceNumber"
                placeholder="Enter invoice number (e.g. 12345)"
              />
            </div>
          </div>

          {formik.touched.invoiceNumber && formik.errors.invoiceNumber && (
            <div style={{ color: 'red', fontSize: '12px', marginBottom: '10px', textAlign: 'center' }}>
              {formik.errors.invoiceNumber}
            </div>
          )}
        </form>

        <div className={styles.updateAndCancel}>
          <div className={styles.updateButton} onClick={formik.handleSubmit}>
            <div className={buttonStyles.YesButtonComponentStyling}>
              {kfExportState.isSubmitting ? 'DOWNLOADING...' : 'DOWNLOAD'}
            </div>
          </div>
          <div className={styles.cancelButton} onClick={onClose}>
            <div className={buttonStyles.NoButtonComponentStyling}>CANCEL</div>
          </div>
        </div>

        <img className={styles.blueLogo} src={BlueLogo} alt="BlueLogo" />
      </div>
    </div>
  );
};

export default KFInvoiceExportPopup;
